import React, {useEffect, useState} from 'react';
import {ISyntheticEvent, SnippetTheme} from './Helpers/Types';
import {TextField} from '@material-ui/core';
import {useStyleContext} from "./Utils/UseStyleContext";

type MultilineTextFieldProps = {
	id: string,
	value: string,
	label: string,
	getValue?: (value: string) => void
	handleChange?: (fieldName: string, value: string) => void
	required?: boolean,
	disabled?: boolean,
	maxLength?: number
}

export default function MultilineTextInput(props: MultilineTextFieldProps) {
	const [value, setValue] = useState(props.value);
	// @ts-ignore
	const {theme} = useStyleContext();
	
	useEffect(() => {
		setValue(props.value);
	}, [props.value])
	
	const handleChange = (event: ISyntheticEvent) => {
		event.preventDefault();
		setValue(event.target.value);
		props.getValue?.(event.target.value);
		props.handleChange?.(props.id, event.target.value);
	};
	
	switch (theme) {
		case SnippetTheme.MaterialUI:
			return (
				<TextField
					style={{marginTop: '5px', marginBottom: '5px'}}
					id={props.id}
					label={props.label}
					value={value}
					required={props.required ? props.required : false}
					onChange={handleChange}
					disabled={props.disabled === true}
					multiline
					rows={3}
					inputProps={{maxLength: props.maxLength}}
				/>
			);
		default:
			return <label>{props.label + (props.required ? "* " : " ")}
				<textarea rows={4} style={{width: '100%'}} id={props.id} onChange={handleChange} required={props.required} disabled={props.disabled === true} value={value} maxLength={props.maxLength}/>
			</label>	
	}
}